import * as R from 'ramda';
// features
import {
  uiTabs,
  telTabs,
  orderTabs,
  driverTabs,
  invoiceTabs,
  generalTabs,
  carrierTabs,
  mobileAppTabs,
  fleetTruckTabs,
  integrationTabs,
  fleetGeneralTabs,
  fleetTrailerTabs,
  serviceVendorTabs,
  communicationTabs,
} from '../../configurations/settings/groups-tab';
// helpers/constants
import * as GC from '../../../constants';
//////////////////////////////////////////////////
// config/invoices?tab=INVOICES_QUICK_BOOKS
export default {
  [GC.MENU_ACTION_CONFIG_UI]: uiTabs,
  [GC.MENU_ACTION_CONFIG_TEL]: telTabs,
  [GC.MENU_ACTION_CONFIG_CLO]: orderTabs,
  [GC.MENU_ACTION_CONFIG_DRIVER]: driverTabs,
  [GC.MENU_ACTION_CONFIG_GENERAL]: generalTabs,
  [GC.MENU_ACTION_CONFIG_CARRIER]: carrierTabs,
  [GC.MENU_ACTION_CONFIG_INVOICES]: invoiceTabs,
  [GC.MENU_ACTION_CONFIG_TRUCK]: fleetTruckTabs,
  [GC.MENU_ACTION_CONFIG_MOBILEAPP]: mobileAppTabs,
  [GC.MENU_ACTION_CONFIG_TRAILER]: fleetTrailerTabs,
  [GC.MENU_ACTION_CONFIG_INTEGRATION]: integrationTabs,
  [GC.MENU_ACTION_CONFIG_FLEET_GENERAL]: fleetGeneralTabs,
  [GC.MENU_ACTION_CONFIG_COMMUNICATION]: communicationTabs,
  [GC.MENU_ACTION_CONFIG_SERVICE_VENDOR]: serviceVendorTabs,
};

const actionToGroupMap = {
  [GC.MENU_ACTION_CONFIG_UI]: GC.UI_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_TEL]: GC.TEL_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_CLO]: GC.CLO_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_TRUCK]: GC.TRUCK_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_DRIVER]: GC.DRIVER_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_GENERAL]: GC.GENERAL_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_CARRIER]: GC.CARRIER_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_TRAILER]: GC.TRAILER_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_INVOICES]: GC.INVOICE_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_MOBILEAPP]: GC.MOBILEAPP_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_INTEGRATION]: GC.INTEGRATION_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_FLEET_GENERAL]: GC.FLEET_GENERAL_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_COMMUNICATION]: GC.COMMUNICATION_CONFIG_GROUP,
  [GC.MENU_ACTION_CONFIG_SERVICE_VENDOR]: GC.SERVICE_VENDOR_CONFIG_GROUP,
};

const groupToActionMap = R.invertObj(actionToGroupMap);

export { actionToGroupMap, groupToActionMap };
